import { PercentPipe } from '@angular/common'
import { Component, inject, Input, ViewEncapsulation } from '@angular/core'

import { ButtonDirective } from 'primeng/button'
import { Card } from 'primeng/card'
import { ProgressSpinner } from 'primeng/progressspinner'
import { Ripple } from 'primeng/ripple'
import { LongRunningJobService } from '@app/services/long-running-job.service'
import { LongRunningJobStatus } from '@app/generated/api/model'
import { TranslatedLongRunningJob } from './long-running-job'
import { LongRunningJobsApi } from './long-running-jobs.api'

@Component({
  selector: 'app-long-running-jobs-detail',
  templateUrl: 'long-running-jobs-detail.html',
  styleUrl: 'long-running-jobs-detail.less',
  encapsulation: ViewEncapsulation.None,
  imports: [
    Card,
    ProgressSpinner,
    ButtonDirective,
    Ripple,
    PercentPipe,
  ],
})

export class LongRunningJobsComponent {
  public readonly longRunningJobService = inject(LongRunningJobService)
  public readonly longRunningJobsApi = inject(LongRunningJobsApi)

  @Input() job?: TranslatedLongRunningJob

  public get LongRunningJobStatus () { return LongRunningJobStatus }

  downloadAttach (attachUuid?: string) {
    if (!this.job || !attachUuid) return
    this.longRunningJobsApi.downloadAttachment(this.job.code, attachUuid)
  }

  onLRJCloseClick (job: TranslatedLongRunningJob) {
    this.longRunningJobService.removeJob(job)
  }
}
